import React from 'react';

import PropTypes from 'prop-types';
import CybsButton from '@cybs-ui/components/lib/button';

const CollapsibleButton = ({ actionBarId, collapsible, dataTest, i18n }) => {
  const onCollapsibleButtonClick = e =>
    Boolean(collapsible.onClick) && collapsible.onClick(e);

  const i18nObject = React.useMemo(
    () => ({
      ariaLabel: i18n.collapsibleButtonLabel,
      tooltipLabel: collapsible.isOpen ? i18n.expandedLabel : i18n.expandedLabel
    }),
    [collapsible, i18n]
  );

  return (
    <CybsButton
      aria-describedby={(i18n.title && actionBarId) || undefined}
      aria-controls={i18n.title && actionBarId}
      dataTest={`${dataTest}-sort`}
      colorScheme="tertiary"
      onClick={onCollapsibleButtonClick}
      variant="icon"
      aria-expanded={collapsible.isOpen}
      i18n={i18nObject}
      iconClass={
        collapsible.isOpen ? 'sortable-ascending' : 'sortable-descending'
      }
      resolution="tiny"
    />
  );
};

CollapsibleButton.displayName = 'CollapsibleButton';

CollapsibleButton.propTypes = {
  /**
   * Level of the heading displayed before the component
   */
  actionBarId: PropTypes.string.isRequired,

  /**
   * Required data testing string
   */
  dataTest: PropTypes.string,
  /**
   * collapsible configuration
   */
  collapsible: PropTypes.shape({
    isOpen: PropTypes.bool,
    onClick: PropTypes.func,
    location: PropTypes.oneOf(['left', 'right'])
  }).isRequired,
  /**
   * Strings for the component.
   */
  i18n: PropTypes.shape({
    collapsibleButtonLabel: PropTypes.string,
    collapsedLabel: PropTypes.string,
    expandedLabel: PropTypes.string,
    title: PropTypes.string.isRequired
  })
};
CollapsibleButton.defaultProps = {
  i18n: {
    collapsibleButtonLabel: 'Accordion toggle',
    collapsedLabel: 'Collapsed',
    expandedLabel: 'Expanded'
  },
  dataTest: ''
};

export default CollapsibleButton;
